import {
    SET_ACCOUNTS,
    SET_ACCOUNT,
    SET_ACCOUNT_COUNT,
  } from '../types/types';
  
  export const setAccounts = (value) => {
    return {
      type: SET_ACCOUNTS,
      payload: { data: value },
    };
  };
  export const setAccountData = (value) => {
    return {
      type: SET_ACCOUNT,
      payload: { data: value },
    };
  };
  
  export const setAccountCount = (value) => {
    return {
      type: SET_ACCOUNT,
      payload: { data: value },
     
    };
  };



  